import { useTranslation } from 'react-i18next'
import { useCurrentUser } from 'context/useCurrentUser'
import { useAvatarOverride } from 'context/useAvatarOverride'
import { Avatar } from 'components/Avatar'
import { ProfileContainerStyled } from './ProfileStyled'

export const Profile = () => {
  const { t } = useTranslation()
  const { currentUser } = useCurrentUser()
  const { avatarOverride } = useAvatarOverride()

  const avatarUrl = avatarOverride !== null ? avatarOverride : (currentUser?.avatar_url || '')

  return (
    <ProfileContainerStyled
      data-intro={t('dashboards_onboarding_steps_step5')}
      data-step='5'>
      <Avatar
        image={avatarUrl}
        name={currentUser?.full_name || ''}
        size="small"
      />
    </ProfileContainerStyled>
  )
}
